
import React from "react";
import "./ProductsJackets.css"; 
import j1 from "../assets/mj1.jpg";
import j2 from "../assets/mj2.jpg";


const products = [
  {
    id: 1,
    name: "Model No.MG-25725-01",
    description: "Premium leather, modern fit, soft inner lining.",
    image: j2,
    link: "/products/jackets1",
  },
  {
    id: 2,
    name: "Model No.MG-25725-02",
    description: "Classic blue denim for everyday casual styling.",
    image: j1,
    link: "/products/jackets2",
  },
 
];

export default function ProductsJackets() {
  return (
    <section className="pj">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men's Jackets</h1>
      <div className="pj__grid">
        {products.map((p) => (
          <article key={p.id} className="pj__card">
            <img className="pj__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="pj__name">{p.name}</h3>
            <p className="pj__desc">{p.description}</p>
            <a className="pj__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

